module.exports = __webpack_public_path__ + "static/media/HeartOfMatter.05e8024c.png";